module.exports = function getResource(label, vars = []) {
    let resources = {
        sortDescribedBy: 'Choosing sorting option will automatically update the products that are displayed to match the selected sorting option',
        filterDescribedBy: 'Choosing filter option will automatically update the products that are displayed to match the selected filter option. To remove a filter, click on the “reset” or “reset all filters” button.',
        categoryNavigation: 'Category Navigation',
        brandNavigation: 'Brand Navigation',
        searchNavigation: 'Search Navigation',
        exploreTheBrand: 'Explore the brand',
        oneProduct: '1 product',
        result: 'result',
        results: 'results',
        products: 'products',
        alternativeKeyword: `We could not find an exact match for "${vars[0]}" and have suggested "${vars[1]}" as a possible alternative.`,
        tooManyProducts: `Number of products exceeds ${vars[0]} items—please use pagination to view all products.`
    };
    return resources[label];
};
